import React from 'react';
import { LevelOfService, isSfas } from '../../../../slices/marketplace/timeline/models/enums/level-of-service.enum';
import { BrokerageType } from '../../../../slices/marketplace/pricing/models/brokerage-type.enum';
import { MarketplacePricing } from '../../../../slices/marketplace/pricing/models/marketplace-pricing.model';
import { ComingSoonCommercialTermsCalculator } from '../../../PracticeBrokerageServices/ComingSoonCommercialTermsTable/CommingSoonCommercialTermsCalculator';
import { ComingSoonCommercialTermsTable } from '../../../PracticeBrokerageServices/ComingSoonCommercialTermsTable/ComingSoonCommercialTermsTable';
import { FeeDetailsVisibilityToggle } from '../FeeDetailsVisibilityToggle/FeeDetailsVisibilityToggle';

interface MyEngagementCommercialTermsProps {
    levelOfService: LevelOfService;
    startFteDvm: number;
    startLtmRevenue: number;
    marketplacePricing: MarketplacePricing;
    isFeeDetailsVisible?: boolean;
    isAdminView: boolean;
    onToggleFeeDetailsVisibility: (next: boolean) => void;
    transactionFeeTooltip?: string;
}

export const MyEngagementCommercialTerms = (props: MyEngagementCommercialTermsProps) => {
    if (isSfas(props.levelOfService)) {
        return null;
    }

    const showFeeDetails = props.isAdminView || !!props.isFeeDetailsVisible;

    const renderHeader = () => (
        <div className="commercial-terms-header">
            <h6>Engagement Commercial Terms</h6>
            {props.isAdminView && (
                <FeeDetailsVisibilityToggle
                    isFeeDetailsVisible={!!props.isFeeDetailsVisible}
                    onToggle={props.onToggleFeeDetailsVisibility}
                />
            )}
        </div>
    );

    if (!showFeeDetails) {
        return null;
    }

    const brokerageType =
        props.levelOfService === LevelOfService.FullServiceBrokerage
            ? BrokerageType.FullService
            : BrokerageType.Discount;

    const data = ComingSoonCommercialTermsCalculator.calculateCommercialTerms(
        props.startFteDvm,
        props.startLtmRevenue,
        brokerageType,
        props.marketplacePricing
    );

    return (
        <div className="commercial-terms-section">
            {renderHeader()}
            <ComingSoonCommercialTermsTable
                data={data}
                transactionFeeTooltip={props.transactionFeeTooltip}
            />
        </div>
    );
};
